import React from 'react'
import styled from 'styled-components'
import './Header.css'

const Header = styled.div`
  width: 100%;
  text-align: left;
  margin: 0 auto;
  background: ${({ theme }) => theme.headerBackground};
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
  align-self: center;

  @media (max-width: 640px) {
    font-size: 1.1em;
  }
`

export default Header
